import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Section = ({
	className = "",
	children,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	...props
}) => {
	return (
		<section
			className={classes(...utilityClassName(utility), ...spacingClassName(spacing), className)}
			{...props}
		>
			{children}
		</section>
	);
};

Section.propTypes = {
	className: string,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	children: node.isRequired,
};

export default Section;
